var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { toast } from 'react-toastify';
import { AccessControlApiService } from '@ClientApi/accessControlApi';
export const SET_ACLS = 'SET_ACLS';
export const SET_GROUPED_ACLS_BY_USER = 'SET_GROUPED_ACLS_BY_USER';
export class SetAcls {
    constructor(acls) {
        this.type = SET_ACLS;
        this.payload = acls;
    }
}
export class SetGroupedAccessControlLists {
    constructor(allAccessControlLists) {
        this.type = SET_GROUPED_ACLS_BY_USER;
        this.payload = allAccessControlLists;
    }
}
export const getAcls = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const acls = yield AccessControlApiService.get();
    dispatch(new SetAcls(acls));
});
export const getAllAccessControlLists = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const allAccessControlLists = yield AccessControlApiService.getGroupedAccessControlLists();
    dispatch(new SetGroupedAccessControlLists(allAccessControlLists));
});
export const createAcl = (acl, AbacusDataManager, isApprovalSetting) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const acls = yield AccessControlApiService.create(acl);
    if (isApprovalSetting) {
        toast.success('Updated approval settings');
    }
    if (AbacusDataManager) {
        // It's not very nice, but this method will dispatch the actual SetAcls action
        // Since several Angular pages are subscribed to access_control_lists, the data needs to go through the manager (for now)
        AbacusDataManager.methods.access_control_lists.set(acls);
    }
    else {
        dispatch(new SetAcls(acls));
    }
});
export const deleteAcl = (id, AbacusDataManager, isApprovalSetting) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const acls = yield AccessControlApiService.delete(id);
    if (isApprovalSetting) {
        toast.success('Updated approval settings');
    }
    if (AbacusDataManager) {
        // It's not very nice, but this method will dispatch the actual SetAcls action
        // Since several Angular pages are subscribed to access_control_lists, the data needs to go through the manager (for now)
        AbacusDataManager === null || AbacusDataManager === void 0 ? void 0 : AbacusDataManager.methods.access_control_lists.set(acls);
    }
    else {
        dispatch(new SetAcls(acls));
    }
});
